<template>
  <div id="stacked-column-chart">
    <div class="chart" ref="chartdiv"></div>
  </div>
</template>
<script>
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import _ from "lodash";
import { REFINERY_ID } from "@/constant";

export default {
  name: "stackedColumnChart",
  props: {
    dataStack: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      chart: null,
    };
  },
  watch: {
    dataStack(val) {
      if (val.length > 0) {
        this.renderStackedChart();
      }
    },
  },
  mounted() {
    this.renderStackedChart();
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.dispose();
    }
  },
  methods: {
    renderStackedChart() {
      let chart = am4core.create(this.$refs.chartdiv, am4charts.XYChart);
      let stack = [];
      let vessel = {};
      stack = _.chain(this.dataStack)
        .groupBy("station_id")
        .map((o, i) => {
          let Refinery = _.findKey(REFINERY_ID, (val) => val == i);
          vessel = _.chain(o)
            .groupBy("vessel.mmsi")
            .map((o) => {
              let vesselName = _.reduce(
                o,
                (vessel, a) => {
                  return _.get(a, "vessel.name");
                },
                0
              );
              let sumVolume = _.reduce(
                o,
                (sum, a) => {
                  let volumes = _.get(a, "volumes").map((a)=>{
                    return Number(a);
                  })                
                  return sum + _.sum(volumes);
                },
                0
              );
              return { [vesselName]: sumVolume };
            })
            .value();
          return {
            Refinery,
            vessel,
          };
        })
        .value();

      for (let i = 0; i < stack.length; i++) {
        for (let j = 0; j < stack[i].vessel.length; j++) {
          const dataStack = stack[i].vessel[j];
          let keyDataStack = Object.keys(dataStack);
          const voloumeStack = stack[i].vessel[j][keyDataStack];
          stack[i][keyDataStack] = voloumeStack;
        }
      }

      chart.data = stack;
      chart.fontSize = 13;
      chart.colors.list = [
        am4core.color("#f7cec7"),
        am4core.color("#e79797"),
        am4core.color("#efb484"),
        am4core.color("#efc989"),
        am4core.color("#c6c69c"),
      ];

      let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
      categoryAxis.dataFields.category = "Refinery";
      categoryAxis.renderer.grid.template.location = 0;
      categoryAxis.renderer.minGridDistance = 20;

      let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
      valueAxis.renderer.inside = false;
      valueAxis.renderer.labels.template.disabled = false;
      valueAxis.min = 0;
      valueAxis.title.text = "ปริมาณน้ำมัน (ลิตร)";

      let key = [];
      for (let i = 0; i < chart.data.length; i++) {
        for (let j = 1; j < _.size(chart.data[i]); j++) {
          let value = chart.data[i];
          let keyValue = Object.keys(value);
          key.push(keyValue[j]);
        }
      }
      let uniqKey = _.uniq(key);
      for (let index = 0; index < uniqKey.length; index++) {
        if (uniqKey[index] != "vessel") {
          this.createSeries(chart, uniqKey[index], uniqKey[index]);
        }
      }
      chart.legend = new am4charts.Legend();
      chart.legend.maxHeight = 50;
      chart.legend.scrollable = true;
    },
    createSeries(chart, field, name) {
      let series = chart.series.push(new am4charts.ColumnSeries());
      series.name = name;
      series.dataFields.valueY = field;
      series.dataFields.categoryX = "Refinery";
      series.sequencedInterpolation = true;
      // series.columns.template.fillOpacity = 0.8;
      series.columns.template.strokeOpacity = 0;
      // series.fill = am4core.color(color);

      // Make it stacked
      series.stacked = true;

      // Configure columns
      series.columns.template.width = am4core.percent(45);
      series.columns.template.tooltipText =
        "[bold]{name}[/]\n[font-size:14px] ปริมาณ : {valueY}";

      series.columns.template.events.on("over", function(event) {
        if (event.target.dataItem) {
          event.target.cursorOverStyle = am4core.MouseCursorStyle.pointer;
        }
      });
      const vm = this;
      series.columns.template.events.on("hit", function(event) {
        let dataItem = event.target.dataItem.categoryX;
        let type = "tanker";
        vm.$store.dispatch("setTankerName", dataItem);
        vm.$store.dispatch("setType", type);
      });
      // Add label
      let labelBullet = series.bullets.push(new am4charts.LabelBullet());
      labelBullet.label.text = "{valueY}";
      labelBullet.locationY = 0.5;
      labelBullet.label.hideOversized = true;

      return series;
    },
  },
};
</script>
<style scoped>
.chart {
  height: 100%;
}
</style>
